import { redirect } from 'react-router-dom'

import { FlowType } from '@cash-web/protos/squareup/cash/plasma/flows/FlowProto.pb'
import { JourneyRoute } from '@cash-web/shared-journey-util-main'

export const cardClientRoutes = [
  {
    id: 'card-request-cash-card-style-picker',
    trackingName: 'Card Request Cash Card Style Picker',
    path: 'dl/view/request-cash-card/style-picker',
    loader: async () => {
      throw redirect(`/web/flow/loader/type/${FlowType.REQUEST_PHYSICAL_CARD}`)
    },
  },
  {
    id: 'card-request-cash-card-with-style-identifier',
    trackingName: 'Card Request Cash Card With Style Identifier',
    path: 'dl/view/request-cash-card/:styleIdentifier',
    loader: async () => {
      throw redirect(`/web/flow/loader/type/${FlowType.REQUEST_PHYSICAL_CARD}`)
    },
  },
  {
    id: 'card-change-card-design-with-style-identifier',
    trackingName: 'Card Change Card Design With Style Identifier',
    path: 'dl/view/change-card-design/:styleIdentifier',
    loader: async () => {
      throw redirect(`/web/flow/loader/type/${FlowType.CHANGE_CARD_DESIGN}`)
    },
  },
  {
    id: 'card-view-home',
    trackingName: 'Card View Home',
    path: 'dl/view/card',
    loader: async ({ context }) => {
      context?.browserNavigate('/account/card')
    },
  },
  {
    id: 'card-recurring-payments-info-sheet',
    trackingName: 'Card Recurring Payments Info Sheet',
    path: 'dl/view/card-recurring-payments/info-sheet',
    handle: {
      unsupported: true,
    },
  },
] as const satisfies JourneyRoute[]
